import { authClient } from "@/lib/authClient";

export type SessionData = ReturnType<typeof authClient.useSession>["data"];

export async function getSessionData() {
  const session = await authClient.getSession();
  return session?.data ?? null;
}
